import { isValidElement, Fragment, createElement, cloneElement } from 'react';
import { cn } from '../../../utils/cn.esm.js';

const isImageConfig = (val) => typeof val === "object" &&
    val !== null &&
    "src" in val;
function addClassNameToChild(child, extra, wrapper = "div") {
    if (!isValidElement(child) || child.type === Fragment) {
        return createElement(wrapper, { className: extra }, child);
    }
    const el = child;
    return cloneElement(el, { className: cn(extra, el.props.className) });
}

export { addClassNameToChild, isImageConfig };
